// Set a form field's value via the native setter so any framework listeners
// (and our own validators) observe the change, then fire input + change.
// Shared by the dev-only signup autofill and login panel helpers.
export function setNativeFieldValue(form: HTMLElement, name: string, value: string): void {
  const field = form.querySelector<HTMLInputElement>(`[name="${name}"]`);
  if (!field) return;

  const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
  if (nativeSetter) {
    nativeSetter.call(field, value);
  } else {
    field.value = value;
  }

  field.dispatchEvent(new Event('input', { bubbles: true }));
  field.dispatchEvent(new Event('change', { bubbles: true }));
}
